import { Report } from './Report'

/**
 * SensorsEvent 定义基本的事件
 */
// eslint-disable-next-line
const root = typeof self == 'object' && self.self === self && self || typeof global == 'object' && global.global === global && global || this

export class SensorsEvent {
  constructor (options) {
    this.$url = options.$url || root.location.href
    this.$title = options.$title || root.document.title
    Object.assign(this, options)
  }

  /**
   * count 计数事件上报
   * @param {string} evtId 事件Id
   * @param {object} evtData 自定义单层JSON对象
   */
  static count (evtId, evtData) {
    try {
      // 初始化神策事件
      const sensorsEvent = new SensorsEvent({
        evtId, // 事件Id
        evtData, // 事件描述json类型
      })
      // 上传自定义事件
      new Report('countEvent', sensorsEvent).report()
    } catch (e) {
      // 报错自动静默处理
      console.log(e)
    }
  }
  /**
   * count 曝光事件上报
   * @param {string} evtId 事件Id
   * @param {object} evtData 自定义单层JSON对象
   */
   static exposure (evtId, evtData) {
    try {
      // 初始化神策事件
      const sensorsEvent = new SensorsEvent({
        evtId, // 事件Id
        evtData, // 事件描述json类型
      })
      // 上传自定义事件
      new Report('exposure', sensorsEvent).report()
    } catch (e) {
      // 报错自动静默处理
      console.log(e)
    }
  }
}
